import { connect } from 'react-redux';
import Item from '../../components/event/Item';
import {
  getEventIds,
  getEventName,
  getEventNames,
  getEvents,
  getMetainf,
  getUniqueChar,
} from '../../reducers/analyticsApp';
import { removeEvent, setEventName } from '../../actions/events/csvEvents';
import { duplicateEvent } from '../../actions/events/events';

const mapStateToProps = (state, { id }) => ({
  event: getEventName(state, id),
  events: getEventNames(state),
  multipleEvents: getEventIds(state).length > 1,
  uniqueChar: getUniqueChar(state, id),
  getEventMetainf: (event) => getMetainf(state, event),
  visible: !!getEventName(state, id),
  allEvents: getEvents(state),
});

const mapDispatchToProps = (dispatch, { id }) => ({
  onRemove: () => dispatch(removeEvent(id)),
  onChangeEvent: (...rest) => dispatch(setEventName(id, ...rest)),
  onDuplicateEvent: () => dispatch(duplicateEvent(id)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onClose: () => (stateProps.allEvents.length < 2 ? null : dispatchProps.onRemove()),
});

const EventsItem = connect(mapStateToProps, mapDispatchToProps, mergeProps)(Item);

export default EventsItem;
